export function loyaltyConsentRuleFactory(consentStatus) {
  return async function loyaltyConsentRule(node) {
    const { loyaltyConsent } = node;

    if (!loyaltyConsent) return true;

    return loyaltyConsent === consentStatus;
  };
}
